import type { intlFormatPropTypes } from "react-intl";
import { useSelector } from "react-redux";

import { Item } from "@ps-design-system/components/ItemV2";

import { selectProfileSSOid } from "../../../app-main/selectors/profile.selectors";
import { trackUpcomingBookingClicked } from "../../analytics/host-hub-analytics";
import type { HostHubUpcomingBooking } from "../../types/model/upcoming-booking";
import {
  formatUpcomingBookingDescription,
  handleBookingClick,
} from "../../utils/host-hub-upcoming-panel.utils";

type HostHubUpcomingPanelBookingItemProps = {
  booking: HostHubUpcomingBooking;
  intl: intlFormatPropTypes;
};

const HostHubUpcomingPanelBookingItem = ({
  booking,
  intl,
}: HostHubUpcomingPanelBookingItemProps) => {
  const ssoid = useSelector(selectProfileSSOid);
  const {
    avatarAlt,
    avatarUrl,
    bookingType,
    endDate,
    guestName,
    mediaAlt,
    mediaUrl,
    primaryCtaRoute,
    startDate,
  } = booking;

  return (
    <Item
      avatar={avatarUrl}
      avatarAlt={avatarAlt}
      description={formatUpcomingBookingDescription({
        endDate,
        intl,
        startDate,
      })}
      media={mediaUrl}
      mediaAlt={mediaAlt}
      mediaSize={40}
      onClick={() => {
        trackUpcomingBookingClicked({ ssoid });
        handleBookingClick(primaryCtaRoute);
      }}
      secondaryDescription={bookingType || undefined}
      title={guestName}
      variant="outline"
    />
  );
};

export default HostHubUpcomingPanelBookingItem;
